import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: reduce ? 0 : y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, description, align = "left", testid }) {
  return (
    <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-cyan-400 font-medium mb-4" data-testid={testid ? `${testid}-eyebrow` : undefined}>
          {eyebrow}
        </p>
      )}
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight text-white" data-testid={testid ? `${testid}-title` : undefined}>
        {title}
      </h2>
      {description && <p className="mt-4 text-sm sm:text-base text-slate-400 leading-relaxed">{description}</p>}
    </Reveal>
  );
}
